import { StyleFunctionProps, mode } from '@chakra-ui/theme-tools';
import type { ComponentStyleConfig } from '@chakra-ui/theme';

const Accordion: ComponentStyleConfig = {
  parts: [
    'Accordion',
    'AccordionItem',
    'AccordionButton',
    'AccordionPanel',
    'AccordionIcon',
  ],
  baseStyle: (props: StyleFunctionProps) => {
    const accordionHeaderColor = props?.accordionProps?.headerColor
      ? props.accordionProps.headerColor
      : props?.colorMode === 'dark'
      ? 'gray.800'
      : 'white';

    const accordionContentBgColor = props?.accordionPanelProps?.bgColor
      ? props.accordionProps.bgColor
      : props?.colorMode === 'dark'
      ? 'gray.800'
      : 'white';
    return {
      Accordion: {},
      AccordionItem: {
        borderColor: mode('gray.200', 'gray.700')(props),
        borderLeft: '1px',
        borderLeftColor: mode('gray.200', 'gray.700')(props),
        borderRight: '1px',
        borderRightColor: mode('gray.200', 'gray.700')(props),
        bg: mode(accordionHeaderColor, accordionHeaderColor)(props),
      },
      AccordionButton: {
        display: 'flex',
        textColor: mode('black', 'white')(props),
        justifyContent: 'space-between',
        _focus: {
          boxShadow: 'none',
        },
      },
      AccordionPanel: {
        padding: 4,
        bg: mode(accordionContentBgColor, accordionContentBgColor)(props),
        textColor: mode('gray.600', 'gray.400')(props),
      },
      AccordionIcon: {},
    };
  },

  variants: {
    shadow: {
      Accordion: {
        shadow: 'md',
      },
    },
    solid: {
      Accordion: {
        shadow: 'none',
      },
    },
    ghost: {
      AccordionItem: {
        border: 'unset',
      },
    },
  },

  defaultProps: {
    variant: 'solid',
  },
};

export default Accordion;
